import { Text, TextProps, Group, Box, rem } from '@mantine/core';
import cn from 'clsx';
import { getTokenByAddress, getTokenBySymbol } from 'src/utils';
import TokenIconAsset from 'src/assets/tokens';

type AddressOrSymbol =
  | {
      address: string;
      symbol?: string;
    }
  | {
      address?: string;
      symbol: string;
    };

export function Token() {
  return null;
}

function TokenIcon({
  address,
  symbol,
  size = 24,
  boxClassName,
  className,
}: AddressOrSymbol & {
  size?: number;
  boxClassName?: string;
  className?: string;
}) {
  const tokenInfo = address ? getTokenByAddress(address) : undefined;
  const Icon =
    TokenIconAsset[
      (symbol || tokenInfo?.symbol) as keyof typeof TokenIconAsset
    ];

  return Icon ? (
    <Box w={size} h={size} style={{ flexShrink: 0 }} className={boxClassName}>
      <Icon
        width={size}
        height={size}
        className={cn('shrink-0', 'rounded-full', className)}
      />
    </Box>
  ) : null;
}

Token.Icon = TokenIcon;

function TokenIconPair({
  token0,
  token1,
  size,
}: {
  token0: AddressOrSymbol;
  token1: AddressOrSymbol;
  size?: number;
}) {
  const outline = '2px solid #181d22';
  return (
    <Group gap={0}>
      <TokenIcon
        {...token0}
        size={size}
        className="z-20 outline outline-2 outline-[#181d22]"
      />
      <TokenIcon
        {...token1}
        size={size}
        className="ml-[-8px] outline outline-2 outline-[#181d22]"
      />
    </Group>
  );
}

Token.IconPair = TokenIconPair;

function TokenName({
  address,
  symbol,
  textProps,
}: AddressOrSymbol & {
  textProps?: TextProps;
}) {
  const tokenInfo = address
    ? getTokenByAddress(address)
    : getTokenBySymbol(symbol!);

  return <Text {...textProps}>{tokenInfo?.name ? tokenInfo?.name : '--'}</Text>;
}

Token.Name = TokenName;

function TokenSymbol({
  address,
  symbol,
  textProps,
}: AddressOrSymbol & {
  textProps?: TextProps;
}) {
  const tokenInfo = address
    ? getTokenByAddress(address)
    : getTokenBySymbol(symbol!);

  return (
    <Text {...textProps}>{tokenInfo?.symbol ? tokenInfo?.symbol : '--'}</Text>
  );
}

Token.Symbol = TokenSymbol;

function TokenSymbolPair({
  token0,
  token1,
  textProps,
}: {
  token0: AddressOrSymbol;
  token1: AddressOrSymbol;
  textProps?: TextProps;
}) {
  const token0Info = token0.address
    ? getTokenByAddress(token0.address)
    : getTokenBySymbol(token0.symbol!);
  const token1Info = token1.address
    ? getTokenByAddress(token1.address)
    : getTokenBySymbol(token1.symbol!);

  return (
    <Text {...textProps}>
      {token0Info?.symbol ? token0Info?.symbol : '--'} /{' '}
      {token1Info?.symbol ? token1Info?.symbol : '--'}
    </Text>
  );
}

Token.SymbolPair = TokenSymbolPair;
